import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="font-mono-num text-xs tracking-[0.2em] uppercase text-stone-500">
          [Authenticating…]
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={defaultRouteFor(user.role)} replace />;
  return children;
}

export function defaultRouteFor(role) {
  if (role === "super_admin" || role === "admin") return "/admin";
  if (role === "client") return "/client";
  if (role === "employee") return "/track";
  return "/login";
}
